import { EventBase } from './EventBase'
export class CrossEvent {
    private static instance: CrossEvent;
    private emitter: any;

    // 室外园区通知stageManager切换场景
    public STAGE_CHANGED:string = "onStageChanged";
    // 查看设备
    public OPEN_EQUIPMENT:string = "onOpenEquipment";
    // 打开摄像头 (不需要跨TS类通信，只需要调用board castChannel,所以不需要事件和事件传参)
    // public OPEN_CAM:string = "onOpenAcam";

    constructor() {
        this.emitter = EventBase.getInstance().emitter;
    }

    public static getInstance(): CrossEvent {
        if (!CrossEvent.instance) {
            CrossEvent.instance = new CrossEvent();
        }
        return CrossEvent.instance;
    }
    public getEmitter(): any {
        if (!this.emitter) {
            this.emitter = EventBase.getInstance().emitter;
        }
        return this.emitter;
    }
}